import { render, staticRenderFns } from "./addTransformerDialog.vue?vue&type=template&id=3e81d948&scoped=true"
import script from "./addTransformerDialog.vue?vue&type=script&lang=js"
export * from "./addTransformerDialog.vue?vue&type=script&lang=js"
import style0 from "./addTransformerDialog.vue?vue&type=style&index=0&id=3e81d948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81d948",
  null
  
)

export default component.exports